import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sdf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (err) => {
  const data = err?.response?.data;
  const detail = data?.detail;
  // iter62 — when the backend's global exception handler attaches an
  // `admin_debug` payload (admin-only), surface its `type: message` so
  // we can diagnose production 500s directly from the admin UI without
  // needing access to the container logs.
  const adminDebug = data?.admin_debug;
  let base;
  if (!detail) base = err?.message || "Something went wrong";
  else if (typeof detail === "string") base = detail;
  else if (Array.isArray(detail)) base = detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  else base = String(detail);
  if (adminDebug && adminDebug.type) {
    const dbg = adminDebug.message ? `${adminDebug.type}: ${adminDebug.message}` : adminDebug.type;
    return `${base} (${dbg})`;
  }
  return base;
};

export default api;
